module.exports = __webpack_public_path__ + "img/markerOrange.c90aaf63.svg";